import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';

// * background color wrapper
export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) =>
    colourOverrideBackground || themeGet('colors.secondary')};

  &.our-mission {
    background-color: ${({ colourOverrideBackground }) =>
      colourOverrideBackground || themeGet('colors.neutral_1')};
  }
`;

// * grid
export const StyledContainer = styled(Container)`
  padding: 50px 0px;

  ${Wrapper}.simple & {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 0;
  }

  ${Wrapper}.simple.extra-top-padding & {
    padding-top: 150px;
  }

  ${Wrapper}.our-mission & {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 70px 85px;

    ${Wrapper}.simple & {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;
      align-items: flex-end;
      padding: 50px 45px 0;
    }

    ${Wrapper}.our-mission & {
      display: flex;
      flex-direction: column;
      align-items: center;

      padding: 70px 30px 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Wrapper}.simple & {
      padding: 70px 0 0;
    }

    ${Wrapper}.our-mission & {
      padding: 70px 85px 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    ${Wrapper}.simple & {
      padding: 70px 45px 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    ${Wrapper}.simple & {
      padding: 70px 90px 0;
    }
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 425px;
  /* object-fit: contain; */

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 548px;

    ${Wrapper}.our-mission & {
      max-width: 426px;
      max-height: 225px;
    }
  }
`;

export const OptionalImage = styled(Image)`
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Wrapper}.our-mission & {
      width: auto;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${Wrapper}.simple & {
    padding-bottom: 45px;
    align-items: flex-start;
  }

  ${Wrapper}.our-mission & {
    h2,
    h3 {
      text-align: center;
    }
  }

  h1,
  h2,
  h3,
  p {
    color: ${themeGet('colors.text-primary')};
    /* for IE */
    width: 100%;

    ${Wrapper}.curriculum & {
      color: ${themeGet('colors.text-secondary')};
    }

    ${Wrapper}.curriculum[id$="simpleBannerPrimary"] & {
      margin-bottom: 10px;
    }
    ${Wrapper}.simple.curriculum &, ${Wrapper}.our-mission.curriculum & {
      color: ${themeGet('colors.text-primary')};
    }
  }
  h1,
  h2,
  h3 {
    padding-bottom: 30px;

    &:nth-child(2n) {
      font-weight: 600;
      padding-bottom: 0;
    }
  }

  p {
    text-align: center;
    /* padding-bottom: 40px; */
    padding-bottom: 0px;

    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 26px;

    ${Wrapper}.simple & {
      font-weight: normal;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 24px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 26px;

      ${Wrapper}.simple & {
        text-align: left;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-size: 22px;
      font-weight: 600;
      letter-spacing: -0.42px;
      line-height: 32px;

      ${Wrapper}.simple & {
        font-size: 18px;
        letter-spacing: -0.2px;
        line-height: 30px;
      }
    }
  }

  a,
  button {
    margin-top: 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Wrapper}.simple & {
      margin-left: 30px;
      padding-bottom: 45px;
      /* max-width: 350px; */
      max-width: 500px;

      min-width: 275px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Wrapper}.simple & {
      padding-bottom: 75px;
    }

    ${Wrapper}.our-mission & {
      h2,
      h3 {
        text-align: left;
      }
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  /* for IE */
  width: 100%;

  ${Wrapper}.simple & {
    align-items: flex-start;
    text-align: center;

    @media only screen and (max-width: 767px) {
      margin: 0 auto;
    }
  }

  ${Wrapper}.our-mission & {
    /* Styles for both */
    h1,
    h2,
    h3,
    h4 {
      color: ${themeGet('colors.secondary')};
      text-align: center;

      .prodigy-font {
        color: ${themeGet('colors.orange')};
      }
    }

    /* Desktop styling */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    /* text-align: left; */
    margin-bottom: 50px;
    max-width: 500px;

    h1,
    h2 {
      margin-bottom: 0;
      padding-bottom: 0;

      margin-bottom: 15px;
    }

    h3,
    h4 {
      font-weight: bold;
      font-size: 34px;
      letter-spacing: -0.22px;
      line-height: 34px;
      padding-bottom: 0;
      max-width: 350px;

      .prodigy-font {
        font-weight: normal;
        font-size: 46px;
        letter-spacing: -0.02px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Wrapper}.simple & {
      text-align: left;
    }
    ${Wrapper}.our-mission & {
      margin-bottom: 70px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Wrapper}.our-mission & {
      margin-bottom: 70px;
      h1,
      h2 {
      }

      h3,
      h4 {
        font-size: 44px;
        letter-spacing: -0.29px;
        line-height: 44px;
        max-width: 450px;

        .prodigy-font {
          font-size: 56px;
          letter-spacing: -0.02px;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
  }
`;
